/** @typedef {import('./user-codes.const').UserCode_Type} $UserCode_Type */

/**
 * @typedef {object} UserCode
 *
 * @property {string} _id
 *
 * @property {string} _member
 * @property {string} _parentCode
 *
 * @property {$UserCode_Type} type
 * @property {string} code
 * @property {number} depth
 * @property {number} index
 *
 * @property {number} chargePrice
 * @property {number} chargePrice_cost
 *
 * @property {object} [chargePrice_attrs]
 * @property {number} [chargePrice_attrs.min]
 * @property {number} [chargePrice_attrs.max]
 *
 * @property {number} salePercent
 * @property {number} salePercent_cost
 *
 * @property {object} [salePercent_attrs]
 * @property {number} [salePercent_attrs.min]
 * @property {number} [salePercent_attrs.max]
 *
 * @property {number} reserveRate
 *
 * @property {UserCode[]} children
 *
 * @property {Date|string|number} [createdAt]
 * @property {Date|string|number} [updatedAt]
 *
 * @property {string} [tempId]
 */

/**
 * @param {Partial<UserCode>} data
 * @returns {UserCode}
 */

export function initUserCode(data = {}) {
    data = {
        ...(data || {}),

        _id: data?._id,

        _member: data?._member || null,
        _parentCode: data?._parentCode || null,

        type: data?.type || "RESERVE",
        code: data?.code || null,
        depth: data?.depth ?? 0,
        index: data?.index ?? 0,

        chargePrice: data?.chargePrice ?? 0,
        chargePrice_cost: data?.chargePrice_cost ?? 0,

        chargePrice_attrs: {
            min: data?.chargePrice_attrs?.min ?? 0,
            max: getMax(data?.children || [], "chargePrice", 10000),
        },

        salePercent: data?.salePercent ?? 0,
        salePercent_cost: data?.salePercent_cost ?? 0,

        salePercent_attrs: {
            min: data?.salePercent_attrs?.min ?? 0,
            // max: getMax(data?.children || [], "salePercent"),
        },

        reserveRate: data?.reserveRate ?? 10,

        children: [...(data?.children || [])].map((code, index) =>
            initUserCode({
                ...code,
                index: index + 1,
                chargePrice_attrs: {
                    min: data?.chargePrice ?? 0,
                },
                salePercent_attrs: {
                    min: data?.salePercent ?? 0,
                },
            }),
        ),

        createdAt: data?.createdAt,
        updatedAt: data?.updatedAt,

        tempId: data?._id || data?.tempId || `${Math.random().toFixed(8)}`.slice(2, 10),
    };

    if (!data?._id) delete data._id;
    if (!data?.createdAt) delete data.createdAt;
    if (!data?.updatedAt) delete data.updatedAt;

    if (data.chargePrice_attrs.max === null) delete data.chargePrice_attrs.max;
    if (data.salePercent_attrs.max === null) delete data.salePercent_attrs.max;

    return data;
}

/**
 *
 * @param {UserCode['children']} children
 * @param {keyof UserCode} fieldName
 */
function getMax(children = [], fieldName, defaultValue = 100) {
    if (children.length < 0) return null;
    return children.reduce((value, item) => {
        if (item[fieldName] < value) return item[fieldName];
        return value;
    }, defaultValue);
}
